import Vue from 'vue';
import Test from '@/components/pages/TestPage/Test.vue'
import Messages from '@/components/pages/AdminHomePage/messages/index.vue'
import StudiesPage from '@/components/pages/AdminHomePage/studies/index.vue'
import UsersPage from '@/components/pages/AdminHomePage/users/index.vue'
import Logs from '@/components/pages/AdminHomePage/logs/index.vue'

Vue.component('test', Test);
Vue.component('messages', Messages);
Vue.component('users', UsersPage);
Vue.component('studies', StudiesPage);
Vue.component('logs', Logs);
